<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="120px">
				<div class="row">
					<el-form-item label="模板类型名称：" style="margin-bottom: 10px;">
						<el-input class="input" :placeholder="tempName" v-model="form.template_name" @input="input"/>
					</el-form-item>
					<el-form-item label-width="90px" label="展示排序：" style="margin-bottom: 10px;margin-left: 40px;">
						<el-input class="input" v-model="form.template_sort" placeholder="请输入内容" />
					</el-form-item>
				</div>
				<el-form-item label="适用表单：" style="margin-bottom: 5px;">
					<el-radio-group v-model="form.template_type">
						<el-radio :label="1">关联业务表格</el-radio>
						<el-radio :label="2">自定义表格</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="form.template_type == 1">
					<el-checkbox-group v-model="form.template_relate">
						<el-checkbox class="checkbox" :label="item.code" name="type"
							v-for="(item,index) in checkList">{{item.message}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<!-- <el-divider v-if="form.template_type != 1"></el-divider> -->
				<!--自定义审批模板-->
				<div v-if="form.template_type != 1" class="row" style="margin-top: 20px;">
					<ApprovalTemplate ref="apptem" :TemplateList='moduleList' :tempName='tempName'
						@itemClick='itemClick' />
					<TemplateControl :TemplateList='moduleList' :selectIndex='selectIndex' @deleteClick='deleteClick'
						@up='up' @down='down' />
				</div>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm()">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import ApprovalTemplate from "../../../components/ApprovalTemplate/ApprovalTemplate.vue"
	import TemplateControl from "../../../components/TemplateControl/TemplateControl.vue"
	import TemplateList from "../../../util/TemplateModule.js"
	import {
		oaTemplate
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			ApprovalTemplate,
			TemplateControl
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '审批内容项的自定义编辑',
				form: {
					template_name: '', //模板名称
					template_sort: '', //展示排序
					template_type: 1, //适用表单:1=关联业务表单,2=自定义表单
					template_relate: [], //关联业务表单
					template_form: [] //自定义表单
				},
				checkList: [],
				moduleList: [],
				tempName: '',
				selectIndex: -1
			}
		},
		mounted() {

			if (this.type != -1) {
				this.form.template_id = this.type;
				this.getOaTemplateDetail();
			}
			this.getAaTemplateList();
			this.tempName = TemplateList.tempName;
			this.moduleList = TemplateList.TemplateList;
		},
		methods: {

			//获取审批模板详情
			getOaTemplateDetail() {
				oaTemplate({
					template_id: this.form.template_id
				}, 3).then(res => {
					if(res.code == 0){
						res.data.template_form.forEach(item=>{
							item.requierd = Boolean(item.requierd)
						})
						res.data.template_relate = res.data.template_relate.map(Number)
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
						this.tempName = res.data.template_name;
						this.moduleList = this.form.template_form.length > 0 ? this.form.template_form : TemplateList.TemplateList
					}
				}).catch(err=>{})
			},

			//自定义表单名称
			input(val){
				this.tempName = val;
			},

			//获取关联业务表单选项
			getAaTemplateList() {
				oaTemplate({}, 6).then(res => {
					if (res.code == 0) {
						this.checkList = res.data.template_relate
					}
				}).catch(err => {})
			},

			//修改控件
			itemClick(index) {
				this.selectIndex = index
			},

			//移除该组件
			deleteClick() {
				this.moduleList.splice(this.selectIndex, 1);
				this.selectIndex = -1
				this.$refs.apptem.clean();
			},

			//下移
			down() {
				this.moduleList.splice(this.selectIndex + 2, 0, this.moduleList[this.selectIndex]);
				this.moduleList.splice(this.selectIndex, 1);
				this.selectIndex = this.selectIndex + 1;
				this.$refs.apptem.updateStyle(this.selectIndex);
			},

			//上移
			up() {
				this.moduleList.splice(this.selectIndex - 1, 0, this.moduleList[this.selectIndex]);
				this.moduleList.splice(this.selectIndex + 1, 1);
				this.selectIndex = this.selectIndex - 1;
				this.$refs.apptem.updateStyle(this.selectIndex);
			},

			//提交表单
			submitForm() {
				if(this.form.template_type == 2){
					this.form.template_form = this.moduleList
				}
				var type = this.type != -1 ? 2 : 0;
				oaTemplate({
					...this.form
				}, type).then(res => {
					if (res.code == 0) {
						this.$emit('close', 0)
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			//返回
			close() {
				this.$emit('close')
			}

		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
		margin-top: 25px;
	}

	/deep/.checkbox.el-checkbox {
		width: 125px;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 590px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 60px;
		height: 60px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>